import createSelector from "../../utils/reselect";

const scopeStateData = (state) => {
  const { scope } = state;
  return scope || {};
};

export const resourceCapacity = createSelector(scopeStateData, (scopeItems) =>
  scopeItems.get("resourceCapacity" || [])
);

export const resourceShifts = createSelector(scopeStateData, (scopeItems) =>
  scopeItems.get("resourceShifts")
);

export const resourcesMonitor = createSelector(scopeStateData, (scopeItems) =>
  scopeItems.get("resourcesMonitor")
);

export const scopeLoading = createSelector(scopeStateData, (scopeItems) =>
  scopeItems.get("scopeLoading")
);

export const overviewLoader = createSelector(scopeStateData, (scopeItems) =>
  scopeItems.get("overviewLoader")
);

export const scopeStatusLoading = createSelector(scopeStateData, (scopeItems) =>
  scopeItems.get("scopeStatusLoading")
);

export const scopeItems = createSelector(scopeStateData, (scopeItems) =>
  scopeItems.get("scopeItems")
);

export const scopesLoading = createSelector(scopeStateData, (scopeItems) =>
  scopeItems.get("scopesLoading")
);

export const scopeItem = createSelector(scopeStateData, (scopeItems) =>
  scopeItems.get("scopeItem")
);

export const getError = createSelector(scopeStateData, (scopeItems) =>
  scopeItems.get("error")
);

export const scopePagination = createSelector(scopeStateData, (scopeItems) =>
  scopeItems.get("scopePagination")
);

export const tasksLoading = createSelector(scopeStateData, (scopeItems) =>
  scopeItems.get("tasksLoading")
);

export const taskLoading = createSelector(scopeStateData, (scopeItems) =>
  scopeItems.get("taskLoading")
);

export const tasks = createSelector(scopeStateData, (scopeItems) =>
  scopeItems.get("tasks")
);

export const taskPagination = createSelector(scopeStateData, (scopeItems) =>
  scopeItems.get("taskPagination")
);

export const scopeProgressSummary = createSelector(scopeStateData, (scopeItems) =>
  scopeItems.get("scopeProgressSummary")
);

export const scopeProgressSummaryLoading = createSelector(scopeStateData, (scopeItems) =>
  scopeItems.get("scopeProgressSummaryLoading")
);
